import React, { Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { store } from '@/shared/store/store';
import { LoadingSpinner } from '@/components';
import {
  setupReduxDebugger,
  monitorActions,
} from '@/shared/utils/reduxDebugger';
import { NotificationProvider } from '@/shared/contexts/NotificationContext';
import { DateTimeProvider } from '@/shared/context/datetime/DateTimeProvider';
import SessionInitializer from '@/shared/components/SessionInitializer';
import OAuthCallbackHandler from '@/shared/components/OAuthCallbackHandler';
import WebSocketInitializer from '@/shared/components/WebSocketInitializer';
import RouteDebugger from '@/shared/components/RouteDebugger';
// import SessionMonitor from '@/shared/components/SessionMonitor'; // DESHABILITADO - Interfiere con cookies HTTP-only
import GlobalNotificationContainer from '@/shared/components/GlobalNotificationContainer';
import UnifiedDebugPanel from '@/shared/components/UnifiedDebugPanel';
import DateTimeTestingPanel from '@/shared/components/DateTimeTestingPanel';
import PWAInstallPrompt from '@/shared/pwa/PWAInstallPrompt';
import PWAUpdateBanner from '@/shared/pwa/PWAUpdateBanner';
import { I18nProvider } from '@/shared/i18n/I18nProvider';
import { allRoutes } from '@/app/routing';
import AppErrorBoundary from '@/shared/components/AppErrorBoundary';
import { envolverRuta } from '@/app/routing/envolverRuta';

const App: React.FC = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      setupReduxDebugger();
      monitorActions();
    }
  }, []);

  return (
    <AppErrorBoundary>
      <I18nProvider>
      <HelmetProvider>
        <Provider store={store}>
          <NotificationProvider>
            <DateTimeProvider>
              <SessionInitializer />
              <WebSocketInitializer />
              <Router
                future={{
                  v7_startTransition: true,
                  v7_relativeSplatPath: true,
                }}
              >
                <OAuthCallbackHandler />
                <RouteDebugger />
                {/* SessionMonitor DESHABILITADO - Interfiere con cookies HTTP-only */}
                <Suspense fallback={<LoadingSpinner />}>
                  <Routes>
                    {allRoutes.map((route, index) => (
                      <Route
                        key={`${route.path}-${index}`}
                        path={route.path}
                        element={envolverRuta(route)}
                      />
                    ))}
                  </Routes>
                </Suspense>
                <GlobalNotificationContainer />
                <UnifiedDebugPanel />
                <DateTimeTestingPanel />
                <PWAInstallPrompt />
                <PWAUpdateBanner />
              </Router>
            </DateTimeProvider>
          </NotificationProvider>
        </Provider>
      </HelmetProvider>
      </I18nProvider>
    </AppErrorBoundary>
  );
};

export default App;
